import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useEffect, useState, useRef } from 'react'
import api from '../services/api'
import TrialExpired from '../pages/TrialExpired'
import { T } from '../theme'

const G = { mono: "'JetBrains Mono', monospace", display: "'Anton', sans-serif", gold: '#4F8EF7', bg: '#0a0908' }

// Cache global — persiste entre navigations dashboard sans re-fetch
let _trialCache = { data: null, userId: null, subId: null, ts: 0 }
const CACHE_TTL = 60_000

// Cet ecran est le SEUL contact d'un coach bloque avec le produit : il couvre
// toutes les routes protegees. Il disait « nous verifions ton profil » et rien
// d'autre — ni ce qui est bloque, ni pour combien de temps, ni s'il y a quelque
// chose a faire. Un coach ne pouvait pas savoir s'il devait patienter,
// recommencer, ou ecrire a quelqu'un.
//
// Il repond desormais aux trois questions, et surtout il porte LE cas ou le
// coach peut se debloquer seul : une invitation de club recue mais pas encore
// acceptee. Depuis que l'acceptation approuve le compte
// (backend club_members.accept_invitation), ouvrir le lien de l'email suffit —
// attendre serait exactement la mauvaise chose a faire.
function PendingApproval() {
  const { logout, user, refreshUser } = useAuth()
  const [checking, setChecking] = useState(false)
  const [checked, setChecked] = useState(false)

  // Un compte approuve pendant que le coach regarde cet ecran y restait
  // coincé : `user` vient du contexte, alimente au login et mis en cache. Sans
  // ce bouton la seule issue etait de se deconnecter et de se reconnecter,
  // ce que rien n'indiquait.
  const handleRefresh = async () => {
    setChecking(true)
    try {
      const fresh = await refreshUser()
      // Si le compte est approuve, ProtectedRoute cesse de rendre cet ecran au
      // re-rendu declenche par la mise a jour du contexte. Sinon on le dit.
      if (!fresh?.is_approved) setChecked(true)
    } catch {
      setChecked(true)
    } finally {
      setChecking(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: G.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px',
    }}>
      <style>{`
        @keyframes logoFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes logoPulse { 0%,100% { opacity: 1; } 50% { opacity: 0.7; } }
        @keyframes fadeIn { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
      <div style={{ maxWidth: 440, textAlign: 'center' }}>
        <div style={{ marginBottom: 32, animation: 'logoFloat 3s ease-in-out infinite' }}>
          <div style={{ fontFamily: G.display, fontSize: 36, letterSpacing: '.08em', color: '#f5f2eb', lineHeight: 1 }}>
            INSIGHT<span style={{ color: G.gold }}>BALL</span>
          </div>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)',
          borderTop: `2px solid ${G.gold}`, padding: '40px 32px',
          animation: 'fadeIn .5s ease forwards',
        }}>
          <div style={{
            fontFamily: G.mono, fontSize: 9, letterSpacing: '.18em',
            textTransform: 'uppercase', color: G.gold, marginBottom: 12,
          }}>
            Validation en cours
          </div>

          <h1 style={{
            fontFamily: G.display, fontSize: 32, textTransform: 'uppercase',
            lineHeight: .92, letterSpacing: '.02em', color: '#f5f2eb', margin: '0 0 16px',
          }}>
            Ton compte est<br /><span style={{ color: G.gold }}>en attente.</span>
          </h1>

          <p style={{
            fontFamily: G.mono, fontSize: 12, color: 'rgba(245,242,235,0.55)',
            lineHeight: 1.7, letterSpacing: '.03em', margin: '0 0 20px',
          }}>
            Ton inscription est bien enregistrée. Chaque compte créé depuis le formulaire public est validé à la main avant d'ouvrir l'accès — c'est ce qui bloque le tien pour l'instant, et ça ne demande rien de ta part. Tu recevras un email dès qu'il sera activé, en général sous 24 h ouvrées.
          </p>

          {/* LE cas ou le coach peut se debloquer seul. Mis en avant parce que
              c'est la seule action utile de tout cet ecran : un invite qui
              attend ici attend pour rien. */}
          <div style={{
            background: 'rgba(79,142,247,0.07)', border: '1px solid rgba(79,142,247,0.25)',
            padding: '14px 16px', marginBottom: 24, textAlign: 'left',
          }}>
            <div style={{
              fontFamily: G.mono, fontSize: 8, letterSpacing: '.16em',
              textTransform: 'uppercase', color: G.gold, marginBottom: 6,
            }}>
              Tu as été invité par un club ?
            </div>
            <p style={{
              fontFamily: G.mono, fontSize: 11, color: 'rgba(245,242,235,0.7)',
              lineHeight: 1.65, margin: 0,
            }}>
              N'attends pas : ouvre le lien de l'email d'invitation. Ton accès
              s'ouvre immédiatement dès que tu l'acceptes, sans validation.
            </p>
          </div>

          {checked && (
            <p style={{
              fontFamily: G.mono, fontSize: 10, color: 'rgba(245,242,235,0.45)',
              lineHeight: 1.6, margin: '0 0 16px',
            }}>
              Ton compte est toujours en attente. Inutile de réessayer tout de
              suite — l'email d'activation te préviendra.
            </p>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button onClick={handleRefresh} disabled={checking} style={{
              padding: '12px 20px', background: G.gold, border: 'none', color: '#0f0f0d',
              fontFamily: G.mono, fontSize: 10, letterSpacing: '.12em',
              textTransform: 'uppercase', fontWeight: 700,
              cursor: checking ? 'not-allowed' : 'pointer', opacity: checking ? 0.6 : 1,
            }}>
              {checking ? 'Vérification…' : "J'ai reçu l'email — vérifier mon accès"}
            </button>
            <button onClick={() => { logout(); window.location.href = '/login' }} style={{
              padding: '12px 20px', background: 'transparent',
              border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(245,242,235,0.55)',
              fontFamily: G.mono, fontSize: 10, letterSpacing: '.12em',
              textTransform: 'uppercase', cursor: 'pointer',
              transition: 'all .15s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(79,142,247,0.3)'; e.currentTarget.style.color = G.gold }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'rgba(245,242,235,0.55)' }}
            >
              Se déconnecter
            </button>
          </div>
        </div>

        <p style={{
          fontFamily: G.mono, fontSize: 9, color: 'rgba(245,242,235,0.3)',
          marginTop: 20, letterSpacing: '.04em',
        }}>
          Une question ? <a href="mailto:contact@insightball.com" style={{ color: G.gold, textDecoration: 'none' }}>contact@insightball.com</a>
        </p>
      </div>
    </div>
  )
}

// Écran du parcours d'invitation club arrêté au paiement.
//
// L'écran d'attente ci-dessus mentait à ce directeur sportif · il lui annonce
// une validation manuelle qui n'aura pas lieu et un email qui ne partira pas,
// alors que son inscription est allée au bout et qu'il ne manque que le
// paiement — qu'il peut relancer seul.
//
// Le bouton rejoue son lien d'invitation, qui est resté valide · le statut
// n'est posé qu'au paiement, et l'endpoint d'acceptation réutilise le compte,
// le club et le client Stripe existants. Aucun chemin nouveau, aucune porte
// ouverte ailleurs.
function PaiementInterrompu({ token }) {
  const { logout } = useAuth()

  return (
    <div style={{
      minHeight: '100vh', background: G.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px',
    }}>
      <style>{`
        @keyframes logoFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes fadeIn { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
      <div style={{ maxWidth: 440, textAlign: 'center' }}>
        <div style={{ marginBottom: 32, animation: 'logoFloat 3s ease-in-out infinite' }}>
          <div style={{ fontFamily: G.display, fontSize: 36, letterSpacing: '.08em', color: '#f5f2eb', lineHeight: 1 }}>
            INSIGHT<span style={{ color: G.gold }}>BALL</span>
          </div>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)',
          borderTop: `2px solid ${G.gold}`, padding: '40px 32px',
          animation: 'fadeIn .5s ease forwards',
        }}>
          <div style={{
            fontFamily: G.mono, fontSize: 9, letterSpacing: '.18em',
            textTransform: 'uppercase', color: G.gold, marginBottom: 12,
          }}>
            Dernière étape
          </div>

          <h1 style={{
            fontFamily: G.display, fontSize: 32, textTransform: 'uppercase',
            lineHeight: .92, letterSpacing: '.02em', color: '#f5f2eb', margin: '0 0 16px',
          }}>
            Ton compte t'attend.
          </h1>

          <p style={{
            fontFamily: G.mono, fontSize: 12, color: 'rgba(245,242,235,0.55)',
            lineHeight: 1.7, letterSpacing: '.03em', margin: '0 0 24px',
          }}>
            Ton club est créé et ton compte est prêt. Il ne manque que le
            paiement pour ouvrir l'accès. Tu peux le finir maintenant, en
            reprenant là où tu t'étais arrêté.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {token ? (
              <a href={`/club-invite/${token}`} style={{
                padding: '12px 20px', background: G.gold, border: 'none', color: '#0f0f0d',
                fontFamily: G.mono, fontSize: 10, letterSpacing: '.12em',
                textTransform: 'uppercase', fontWeight: 700,
                textDecoration: 'none', display: 'block',
              }}>
                Finir mon inscription
              </a>
            ) : (
              <p style={{
                fontFamily: G.mono, fontSize: 11, color: 'rgba(245,242,235,0.55)',
                lineHeight: 1.7, margin: 0,
              }}>
                Écris-nous et on te renvoie ton lien.
              </p>
            )}
            <button onClick={() => { logout(); window.location.href = '/login' }} style={{
              padding: '12px 20px', background: 'transparent',
              border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(245,242,235,0.55)',
              fontFamily: G.mono, fontSize: 10, letterSpacing: '.12em',
              textTransform: 'uppercase', cursor: 'pointer',
              transition: 'all .15s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(79,142,247,0.3)'; e.currentTarget.style.color = G.gold }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'rgba(245,242,235,0.55)' }}
            >
              Se déconnecter
            </button>
          </div>
        </div>

        <p style={{
          fontFamily: G.mono, fontSize: 9, color: 'rgba(245,242,235,0.3)',
          marginTop: 20, letterSpacing: '.04em',
        }}>
          Une question ? <a href="mailto:contact@insightball.com" style={{ color: G.gold, textDecoration: 'none' }}>contact@insightball.com</a>
        </p>
      </div>
    </div>
  )
}

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth()
  const location = useLocation()
  const [trialStatus, setTrialStatus] = useState(null)
  const [trialLoading, setTrialLoading] = useState(true)
  const fetchedRef = useRef(false)

  useEffect(() => {
    if (!isAuthenticated || loading) { setTrialLoading(false); return }

    const now = Date.now()
    const cacheValid = (
      _trialCache.data &&
      _trialCache.userId === user?.id &&
      _trialCache.subId === (user?.stripe_subscription_id || null) &&
      (now - _trialCache.ts) < CACHE_TTL
    )

    if (cacheValid) {
      setTrialStatus(_trialCache.data)
      setTrialLoading(false)
      return
    }

    if (fetchedRef.current) return
    fetchedRef.current = true
    setTrialLoading(true)

    api.get('/subscription/trial-status')
      .then(r => {
        setTrialStatus(r.data)
        _trialCache = { data: r.data, userId: user?.id, subId: user?.stripe_subscription_id || null, ts: Date.now() }
      })
      .catch(() => {
        const fallback = { access: 'trial' }
        setTrialStatus(fallback)
        _trialCache = { data: fallback, userId: user?.id, subId: user?.stripe_subscription_id || null, ts: Date.now() }
      })
      .finally(() => setTrialLoading(false))
  }, [isAuthenticated, loading, user?.stripe_subscription_id])

  useEffect(() => { fetchedRef.current = false }, [user?.stripe_subscription_id])

  // Loader
  if (loading || trialLoading) {
    return (
      <div style={{
        minHeight: '100vh', background: G.bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 32, height: 32, border: `2px solid ${G.gold}`,
            borderTopColor: 'transparent', borderRadius: '50%',
            animation: 'spin .7s linear infinite', margin: '0 auto 12px'
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
          <span style={{ fontFamily: G.mono, fontSize: 9, letterSpacing: '.2em', textTransform: 'uppercase', color: G.gold }}>
            Chargement...
          </span>
        </div>
      </div>
    )
  }

  // Non connecté
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // PAIEMENT INTERROMPU — AVANT l'écran d'attente, et l'ordre compte.
  //
  // « A-t-il payé » est une question plus spécifique que « sait-on qui c'est ».
  // Un directeur sportif invité qui n'a pas fini son paiement doit voir
  // l'écran du paiement, jamais celui de la validation manuelle — y compris
  // si `is_approved` revenait un jour à false pour une autre raison.
  //
  // Le drapeau est calculé par le SERVEUR (services/paiement_interrompu.py) à
  // partir de trois signes que le frontend n'a pas : compte inactif, client
  // Stripe posé, invitation encore PENDING. Ne pas le redériver ici — c'est
  // en laissant un détecteur se réécrire côté client qu'on s'est retrouvé
  // avec cinq versions du détecteur de membre de club le 06/08.
  if (user?.paiement_interrompu === true && location.pathname !== '/onboarding') {
    return <PaiementInterrompu token={user.paiement_invite_token} />
  }

  // Compte non approuvé — écran d'attente (sauf onboarding)
  if (user?.is_approved === false && location.pathname !== '/onboarding') {
    return <PendingApproval />
  }

  // Trial expiré OU sub annulée
  const isExpiredOrCanceled = (
    trialStatus?.access === 'expired' ||
    (trialStatus?.access === 'no_trial' && user?.trial_ends_at != null)
  )

  if (isExpiredOrCanceled) {
    return (
      <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
        <div style={{ filter: 'blur(6px)', pointerEvents: 'none', userSelect: 'none', opacity: 0.35 }}>
          {children}
        </div>
        <TrialExpired />
      </div>
    )
  }

  return children
}

export default ProtectedRoute
